module.exports = __webpack_public_path__ + "static/media/loader.072d61f8.gif";